import { g as getWindowScroll } from './getWindowScroll-E89-q1-1.js';
import { g as getWindow } from './getWindow-JtVpfBBJ.js';
import { b as isHTMLElement } from './instanceOf-DT24G-dX.js';
import { g as getHTMLElementScroll } from './getHTMLElementScroll-RRV0AW8Y.js';

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

export { getNodeScroll as g };
//# sourceMappingURL=getNodeScroll-BHIGmasm.js.map
